import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const removeAccessContext = React.createContext({});
export let removeAccessMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMRemoveAccess = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  removeAccessMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(removeAccessMachine);

  return {
    removeAccessMachine,
    removeAccessState: state,
    removeAccessSend: send,
  };
};
